import { StyleSheet } from 'react-native';

import CouponApplier from './CouponApplier';
import Colors from '../../constants/Colors';
import FeatureFlags from '../../constants/FeatureFlags';
import useColorScheme from '../../hooks/useColorScheme';
import { formatPrice } from '../../utils/locations';
import Row, { TransparentRow } from '../Row';
import { TextBody, TextFinePrint } from '../StyledText';

export default function PriceSummaryWithCoupon({
  total,
  careCreditBalance,
  discountApplied,
  setDiscountApplied,
}: {
  total: number;
  careCreditBalance: number | undefined;
  discountApplied: {
    discount: number;
    discountType: 'percentage' | 'fixed';
  } | null;
  setDiscountApplied: (
    discount: {
      discount: number;
      discountType: 'percentage' | 'fixed';
    } | null
  ) => void;
}) {
  const theme = useColorScheme();
  return (
    <>
      <Row style={[styles.row, { marginTop: 12, marginBottom: 6 }]}>
        <TextBody>Subtotal (USD)</TextBody>
        <TransparentRow>
          <TextBody>{formatPrice(total)}</TextBody>
        </TransparentRow>
      </Row>
      {careCreditBalance ? (
        <Row style={styles.row}>
          <TextBody>BumoCredit</TextBody>
          <TextBody>{`-${formatPrice(
            Math.min(careCreditBalance, total)
          )}`}</TextBody>
        </Row>
      ) : null}
      {!FeatureFlags.COUPON_CODES ? null : !careCreditBalance ? (
        <CouponApplier
          onCouponApplied={(discount, discountType) => {
            if (discount === null || discountType === null) {
              setDiscountApplied(null);
            } else {
              setDiscountApplied({ discount, discountType });
            }
          }}
        />
      ) : null}
      <Row style={[styles.row, styles.total]}>
        <TextBody bold>Total Due (USD)</TextBody>
        <TextBody bold>
          {formatPrice(
            Math.max(
              0,
              careCreditBalance
                ? total - careCreditBalance
                : calculatePriceWithDiscount(total, discountApplied)
            )
          )}
        </TextBody>
      </Row>
      <TextFinePrint style={{ color: Colors[theme].textSecondary }}>
        Includes all service fees
      </TextFinePrint>
    </>
  );
}

function calculatePriceWithDiscount(
  price: number,
  discount: {
    discount: number;
    discountType: 'percentage' | 'fixed';
  } | null
) {
  if (!discount) {
    return price;
  }

  if (discount.discountType === 'percentage') {
    return price - price * discount.discount;
  }
  return price - discount.discount;
}

const styles = StyleSheet.create({
  row: {
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  total: {
    marginTop: 40,
    marginBottom: 0,
  },
});
